
import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.ENCRYPTION_KEY ||"MyAESLoginKey123";

export function encryptData(plainText) {
  const encrypted = CryptoJS.AES.encrypt(plainText, CryptoJS.enc.Utf8.parse(SECRET_KEY), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}
export default encryptData;